<select #comboBox [style.width.px]="width" [style.width]="width !== undefined ? width : '100%'"
  [(ngModel)]="selectedFeatureCode" [disabled]="disabled" [hidden]="!visible" [class.combo-box-required]="required"
  (change)="updateBindedField($event);onChange($any($event.target).value);" (blur)="onTouched()" [tabindex]="tabindex">
  <ng-template ngFor let-item [ngForOf]="model.dataList">
    <option value="{{item.FeatureCode}}">{{item.FeatureCodeName}}</option>
  </ng-template>
</select>